import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { CalendarData } from '../types';

export const isValidCalendar = (obj: CalendarData): boolean =>
  Boolean(obj?.data?.getCalendarWidget && !isEmptyObject(obj.data.getCalendarWidget));